import { createFileRoute } from "@tanstack/react-router";
import AdminPartsShipmentDetail from "@/pages/admin/AdminPartsShipmentDetail";

export const Route = createFileRoute("/_adminLayout/admin/parts/shipments/$id")({
  component: AdminPartsShipmentDetail,
});
